<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div
    class="orangehrm-buzz-profile-image"
    :class="{'orangehrm-buzz-profile-image--clickable': clickable && empNumber}"
    :role="clickable && empNumber ? 'button' : null"
    :tabindex="clickable && empNumber ? 0 : null"
    @click="onClick"
    @keydown.enter="onClick"
    @keydown.space.prevent="onClick"
  >
    <img alt="profile picture" :src="imageSrc" />
  </div>
</template>

<script>
import {computed} from 'vue';
import useBuzzEmployeeMentionDialog from '@/orangehrmBuzzPlugin/util/composable/useBuzzEmployeeMentionDialog';

export default {
  name: 'ProfileImage',
  props: {
    employee: {
      type: Object,
      required: true,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const {openEmployeeMention} = useBuzzEmployeeMentionDialog();

    const empNumber = computed(() => {
      const value = props.employee?.empNumber;
      if (value === null || value === undefined) {
        return null;
      }
      const parsed = Number(value);
      return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
    });

    const imageSrc = computed(() => {
      return `../pim/viewPhoto/empNumber/${props.employee.empNumber}`;
    });

    const onClick = () => {
      if (!props.clickable || !empNumber.value) {
        return;
      }
      openEmployeeMention(empNumber.value);
    };

    return {
      empNumber,
      imageSrc,
      onClick,
    };
  },
};
</script>

<style lang="scss" scoped>
.orangehrm-buzz-profile-image {
  & img {
    width: 45px;
    height: 45px;
    display: flex;
    flex-shrink: 0;
    border-radius: 100%;
    box-sizing: border-box;
    justify-content: center;
  }

  &--clickable {
    cursor: pointer;

    &:hover img,
    &:focus img {
      opacity: 0.85;
    }

    &:focus {
      outline: none;

      img {
        box-shadow: 0 0 0 2px $oxd-primary-one-color;
      }
    }
  }
}
</style>
